var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';
import { FormattedDate } from 'react-intl';
import withSwipeListeners from '../lib/withSwipeListeners';
import classNames from 'classnames';
import { compose } from 'recompose';
import Translate from './Translate';

var Notification = function (_Component) {
  _inherits(Notification, _Component);

  function Notification() {
    _classCallCheck(this, Notification);

    return _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).apply(this, arguments));
  }

  _createClass(Notification, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          hideNotification = _props.hideNotification,
          swipes = _props.swipes;


      var swipeDirection = Object.entries(swipes).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            direction = _ref2[0],
            value = _ref2[1];

        return prevProps.swipes[direction] < value ? direction : acc;
      }, null);

      if (swipeDirection && !swipeDirection.includes('down')) hideNotification(swipeDirection);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.removeNotification();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          title = _props2.title,
          text = _props2.text,
          component = _props2.component,
          show = _props2.show,
          timestamp = _props2.timestamp,
          hideNotification = _props2.hideNotification,
          removeNotification = _props2.removeNotification,
          _props2$timeout = _props2.timeout,
          timeout = _props2$timeout === undefined ? 5 : _props2$timeout,
          action = _props2.action,
          defaultAction = _props2.defaultAction,
          btnText = _props2.btnText,
          icon = _props2.icon,
          direction = _props2.direction;


      return React.createElement(
        CSSTransition,
        {
          'in': show,
          timeout: 200,
          classNames: 'notification-wrapper',
          unmountOnExit: true,
          onExited: function onExited() {
            return removeNotification();
          } },
        React.createElement(
          'div',
          {
            className: classNames('notification', {
              'direction-left': direction === 'left',
              'direction-up': direction === 'up'
            }) },
          React.createElement('div', {
            className: classNames('timeout-bar', {
              'timeout-bar--infinite': timeout === 0
            }),
            style: { animationDuration: timeout + 's' },
            onAnimationEnd: function onAnimationEnd() {
              return hideNotification();
            }
          }),
          React.createElement(
            'div',
            {
              className: classNames('content', { 'has-action': defaultAction }),
              onClick: function onClick() {
                if (defaultAction) {
                  defaultAction();
                  hideNotification();
                }
              } },
            React.createElement(
              'div',
              { className: 'head' },
              icon && React.createElement('img', { className: 'icon', src: icon }),
              React.createElement(
                'div',
                { className: 'title' },
                title
              ),
              timestamp && React.createElement(
                'div',
                { className: 'date' },
                React.createElement(FormattedDate, {
                  value: timestamp,
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit'
                })
              )
            ),
            React.createElement(
              'div',
              null,
              component || text
            )
          ),
          React.createElement(
            'div',
            { className: 'notification-buttons' },
            btnText && defaultAction && React.createElement(
              'a',
              {
                className: 'notification-button',
                onClick: function onClick() {
                  hideNotification();
                  action ? action() : defaultAction();
                } },
              React.createElement(Translate, {
                id: btnText.id,
                defaultMessage: btnText.defaultMessage
              })
            ),
            React.createElement(
              'a',
              { className: 'notification-button', onClick: hideNotification },
              React.createElement(Translate, { id: 'action.close', defaultMessag: 'Close' })
            )
          )
        )
      );
    }
  }]);

  return Notification;
}(Component);

var enhance = compose(withSwipeListeners);

export default enhance(Notification);